export default function Cardholder(name, billingAddress, phone) {
  this.name = name;
  this.billingAddress = billingAddress;
  this.phone = phone;

  return {
    getSnakeCase: getSnakeCase.bind(this),
  };
}

function orUndefined(v) {
  return v || undefined;
}

function getSnakeCase() {
  return {
    name: orUndefined(this.name),
    billing_address: convertAddress(this.billingAddress),
    phone: {
      number: orUndefined(this.phone),
    },
  };
}

function convertAddress(a) {
  return (
    orUndefined(a) && {
      address_line1: a.addressLine1,
      address_line2: a.addressLine2,
      city: a.city,
      state: a.state,
      zip: a.zip,
      country: a.country,
    }
  );
}
